module.exports = __webpack_public_path__ + "static/message-902cf29e2ff06c5d21da2cb404d7814f.png";